import { CALENDAR_ROLES, CALENDAR_ROLE_HINTS, CALENDAR_ROLE_LABELS, isCalendarRole } from '@cerebro-diem/core';
import type { CalendarRole } from '@cerebro-diem/core';
import { compactInput } from '../../components/styles';

export interface RoleListCalendar {
  id: string;
  name: string;
  color: string | null;
  role: CalendarRole;
}

/** A connection's calendars, each with its role picker; the same list for every calendar source. */
export default function CalendarRoleList({
  calendars,
  disabled,
  onChange,
}: {
  calendars: RoleListCalendar[];
  disabled: boolean;
  onChange: (id: string, role: CalendarRole) => void;
}) {
  return (
    <ul className="space-y-2">
      {calendars.map((calendar) => (
        <li key={calendar.id} className="flex flex-wrap items-center justify-between gap-2">
          <span className="inline-flex min-w-0 items-center gap-2">
            <span
              aria-hidden="true"
              className="h-3 w-3 shrink-0 rounded-full border border-outline/30"
              style={{ backgroundColor: calendar.color ?? 'transparent' }}
            />
            <span className="break-words">{calendar.name}</span>
          </span>
          <select
            aria-label={`Role of ${calendar.name}`}
            value={calendar.role}
            disabled={disabled}
            onChange={(e) => {
              if (isCalendarRole(e.target.value)) onChange(calendar.id, e.target.value);
            }}
            className={`${compactInput} w-auto`}
          >
            {CALENDAR_ROLES.map((role) => (
              <option key={role} value={role} title={CALENDAR_ROLE_HINTS[role]}>
                {CALENDAR_ROLE_LABELS[role]}
              </option>
            ))}
          </select>
        </li>
      ))}
    </ul>
  );
}
